import React, { useEffect, useState } from "react";
import Social from "./Social";
import Header from "./Header";
import Footer from "./Footer";
import NewsText from "./NewsText";
import YandexRec from "./YandexRecWidget";
import SmiJs from "../components/SmiJs";
import * as fixed from "../utils/fixedBlock";
import { AdfoxInvisible } from "../components/adfoxBlocks/InvisibleAdfox";
import { adfoxOptions } from "./adfox/adfoxOptions";
import { useAdBlockStatus } from "../components/DetectAdBlock";
import { blocksId } from "./adblocks/adBlocksId/adBlocksId";
import { fetchJsonAds } from "../services/fetchJsonAds";
import { fetchJsonAdsCount } from "../constants";
import AnalyticsTracker from "../components/AnalyticsTracker";
import { useBillingNotice } from "../services/billingNotice";
import { resolveJsonObjectId } from "../utils/adConfig";
import { Feed } from "../components/jsonBlocks/Feed/Feed";

const Template900Component = ({
    isFull,
    isDesktop,
    categories,
    news,
    context,
    use_html_render,
    fprVersion,
    showMainLogo,
    currentDomain,
    userId,
    showId,
}) => {
    const [billingNoticeUrl, setBillingNoticeUrl] = useState(null);
    const [jsonData, setJsonData] = useState([]);

    const adfoxBlocks = adfoxOptions[fprVersion] || adfoxOptions["main"];
    const showAdfox = useAdBlockStatus(adfoxBlocks, isDesktop, isFull);

    const adBlocks = blocksId[fprVersion] || blocksId["main"];
    const bundleObjectId = isFull
        ? isDesktop
            ? adBlocks.json.fullPc
            : adBlocks.json.fullMob
        : isDesktop
          ? adBlocks.json.prevPc
          : adBlocks.json.prevMob;
    const objectId = resolveJsonObjectId({ isFull, isDesktop, fallback: bundleObjectId });

    useBillingNotice(billingNoticeUrl);

    useEffect(() => {
        if (!userId || !showId) return;
        console.log(objectId, userId, showId);

        const fetchData = async () => {
            try {
                const data = await fetchJsonAds(objectId, fetchJsonAdsCount, userId, showId, context.utm_term);
                setJsonData(data.news || []);
                setBillingNoticeUrl(data.billingNoticeUrl);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [userId, showId, objectId]);

    useEffect(() => {
        document.body.classList = "is-constructor red-theme";

        import("./js/app.js").then(() => {
            console.log("template900js load done");

            fixed.connect({
                block: $(".sb-wrapper"),
                beforeTop: $("#main-content"),
                untilBottom: $("#main-content"),
            });

            fixed.connect({
                block: $(".social-desktop"),
                beforeTop: $("#main-content"),
                untilBottom: $("#main-content"),
            });
        });
    }, []);

    if (use_html_render) {
        return null; // необходимо для индексации в Опере
    }

    return (
        <div className="out">
            <SmiJs />
            <div className="out__inner">
                <Header categories={categories} showMainLogo={showMainLogo} />
                <div className="inner inner-sm">
                    <div className="constructor">
                        <div className="constructor__wrap">
                            <div className="constructor__soc mobile-hide" />
                            <div className="constructor__sidebar tablet-hide" />
                        </div>
                        <div className="constructor__wrap" id="main-content">
                            <Social news={news} context={context} />
                            <main className="constructor__main">
                                <div className="simplebanner">
                                    <div className="t900-img-wrapper">
                                        <img
                                            src={news.image.replace("/public/media/", "/public/media/680x340/")}
                                            alt={news.title}
                                        />
                                        <h1 className="t900-news-title">{news.title}</h1>
                                    </div>
                                    <div className="simplebanner__source">
                                        <div className="simplebanner__item">
                                            Источник материала:{" "}
                                            <a target="_blank" href={news.source_url}>
                                                {news.source_title}
                                            </a>
                                        </div>
                                        <div className="simplebanner__item">
                                            <div className="simplebanner__date">Время на чтение: 5 минут</div>
                                        </div>
                                    </div>
                                </div>
                                <NewsText
                                    news={news}
                                    isFull={isFull}
                                    isDesktop={isDesktop}
                                    showAdfox={showAdfox}
                                    options={adfoxBlocks}
                                    objectId={objectId}
                                    showId={showId}
                                    jsonData={jsonData.slice(0, 5)}
                                />
                                <AdfoxInvisible isTop={true} />
                                <AdfoxInvisible isTop={false} />
                                <YandexRec context={context} />
                                <div className="constnews"></div>
                            </main>
                            <aside className="constructor__sidebar tablet-hide" id="sb-right">
                                <div className="sb-wrapper"></div>
                            </aside>
                        </div>
                    </div>
                    {!showAdfox && (
                        <Feed
                            object={objectId}
                            isDesktop={isDesktop}
                            userId={userId}
                            showId={showId}
                            initialData={jsonData.slice(6, 48)}
                            utmTerm={context.utm_term}
                        />
                    )}
                </div>
                <Footer showMainLogo={showMainLogo} domain={currentDomain} />
            </div>
            <AnalyticsTracker
                newsId={news.id}
                streamId={context.stream_id}
                isFull={isFull}
                sessionId={context.session_id}
                visitorId={context.visitor_id}
                utmParams={context.utm_params}
                device={context.device}
                browser={context.browser}
            />
        </div>
    );
};

export default Template900Component;
